export default [
    {
        path: '/board',
        component: () => import('@/views/board/board-main'),
        // children: [
        //     {
        //         path: 'operation-board',
        //         component: () => import('@/views/board/operation/operation-board-index')
        //     },
        //     {
        //         path: 'bossBoard',
        //         component: () => import('@/views/board/boss/bossBoard')
        //     },
        // ]
    },
]
